import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderResizeService {
  headerElement: HTMLElement;

  resizeObserver: ResizeObserver;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.initialize();
  }

  initialize(): void {
    const isSSR = isPlatformServer(this.platformId);
    if (isSSR) {
      return;
    }
    this.resizeObserver = new ResizeObserver(
      this.debounce((entries: any) => {
        entries.forEach(() => {
          this.setHeightOffsetForHeader();
        });
      }, 50)
    );
  }

  observe(element: HTMLElement): void {
    if (!!this.resizeObserver && !!element) {
      this.resizeObserver.observe(element);
    }
  }

  unobserve(element: HTMLElement): void {
    if (!!this.resizeObserver && !!element) {
      this.resizeObserver.unobserve(element);
    }
  }

  private debounce(f: any, delay: number) {
    let timer: ReturnType<typeof setTimeout> | number = 0;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => f.apply(this, args), delay);
    };
  }

  private setHeightOffsetForHeader() {
    const headerElement = this.document.getElementById('header');
    this.document.body.style.setProperty('--py-header-height', `${headerElement?.getBoundingClientRect()?.height ?? 0}px`);
  }
}
